import { render, staticRenderFns } from "./editPremiumOffers.vue?vue&type=template&id=47dd737e&"
import script from "./editPremiumOffers.vue?vue&type=script&lang=js&"
export * from "./editPremiumOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports